import React from 'react';
import ServiceDetail from '@/components/services/ServiceDetail';

export default function GarageDoorOpenerRepair() {
  return <ServiceDetail serviceKey="openers" />;
}